"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatcher = void 0;
var hot_patcher_1 = require("hot-patcher");
var __patcher = null;
function getPatcher() {
    if (!__patcher) {
        __patcher = new hot_patcher_1.HotPatcher();
    }
    return __patcher;
}
exports.getPatcher = getPatcher;
